module.exports = __webpack_public_path__ + "img/get_ticket_1.174eea98.png";